import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a0b4035"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0b4035')) {
      api.createRecord('4a0b4035', component.options)
    } else {
      api.reload('4a0b4035', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4a0b4035", function () {
      api.rerender('4a0b4035', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/importfailed/index.vue"
export default component.exports